// src/slices/dashboardSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

// Fetch dashboard statistics
export const fetchDashboardStats = createAsyncThunk('dashboard/fetchStats', async () => {
  const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/admin/get-dashboard-stats`);
  return response.data; // Ensure the API returns the expected structure
});

const dashboardSlice = createSlice({
  name: 'admin_dashboard',
  initialState: {
    stats: {
      users_count: 0,
      clients_per_coach: { labels: [], data: [] },
      enquiries_count: 0,
    },
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.stats = action.payload.data; // Update state with fetched data
        state.loading = false;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // Store error message
      });
  },
});

export default dashboardSlice.reducer;